import ShieldCheck from "./SVG/shield-check.svg?react";

const ShieldCheckIcon = () => {
  return <ShieldCheck />;
};

export default ShieldCheckIcon;
